<form class="dynamic-form" [formGroup]="form" (submit)="onSubmit($event)">
  <mat-tab-group *ngIf="tabArr.length>0">
    <mat-tab *ngFor="let tab of tabArr; let i = index" disabled="{{tab.disabled}}">
      <ng-template mat-tab-label>
        <mat-icon *ngIf="tab.icon.length > 0" class="tab-icon">{{tab.icon}}</mat-icon>
        {{tab.label}}
      </ng-template>
      <div *ngFor="let formItem of formItems;" style="display: inline;">
        <div *ngIf="formItem.tabIndex===i" [ngClass]="(formItem.componentFixedWidth !== undefined)?(formItem.componentFixedWidth === 2)? 'formItem2Div':((formItem.componentFixedWidth === 3)? 'formItem3Div':''):'formItem'">
        <ng-container viasFormItem [item]="formItem" [form]="form" (itemClick)="onFormItemClick(formItem)">
        </ng-container>
      </div>
      </div>
    </mat-tab>
  </mat-tab-group>
  <ng-template [ngIf]="tabArr.length===0">
    <div *ngFor="let formItem of formItems;" [ngClass]="(formItem.componentFixedWidth !== undefined)?(formItem.componentFixedWidth === 2)? 'formItem2Div':((formItem.componentFixedWidth === 3)? 'formItem3Div':''):'formItem'">
      <ng-container viasFormItem [item]="formItem" [form]="form" (itemClick)="onFormItemClick(formItem)">
      </ng-container>
    </div>
  </ng-template>
  <button mat-raised-button type="button" color="primary" *ngIf="tabArr.length>0" (click)='moveToNext(false)'>
    <mat-icon >arrow_back_ios</mat-icon> {{"previous"|translate}}
  </button>
  <button mat-raised-button type="button" color="primary" *ngIf="tabArr.length>0" (click)='moveToNext(true)'>
    {{"next"|translate}} <mat-icon>arrow_forward_ios</mat-icon>
  </button><br/>
  <vias-button *ngIf="hasSubmitBtn" [item]="submitBtnItem" [form]="form"></vias-button>
</form>